export function cleanCustomerGID(gid) {
  return gid.replace('gid://shopify/Customer/', '');
}

export function cleanProductGID(gid) {
  return gid.replace('gid://shopify/Product/', '');
}

export function cleanVariantGID(gid) {
  return gid.replace('gid://shopify/ProductVariant/', '');
}
